import Vue from 'vue'
import { PopupManager } from 'element-ui/src/utils/popup'
import UmForm from './index.vue'
const UmFormConstructor = Vue.extend(UmForm) // 直接将Vue组件作为Vue.extend的参数
let instance
const instances = []
let seed = 1
/**
 *
 * @param {Object} options 表单信息
 * @returns {*}
 * @constructor
 */
const CustomUmForm = (options) => {
  options = options || {}
  const id = 'export_' + seed++
  instance = new UmFormConstructor({
    data: {
      visible: true
    },
    propsData: {
      options: options.options || {},
      title: options.title || '',
      width: options.width || 500,
      labelWidth: options.labelWidth || 100
    }
  }) // 实例化
  instance.id = id
  instance.$on('change', val => {
    if (options.change) {
      options.change(val).then(d => {
        instance.visible = false
      }).catch(e => {
        instance.$errorHandle(e)
      })
    }
  })
  instance.$mount()
  document.body.appendChild(instance.$el)
  // 弹框自动生成层级 不需要手动赋值
  // instance.$el.style.zIndex = PopupManager.nextZIndex()
  instances.push(instance)

  return instance
}
CustomUmForm.closeAll = function() {
  for (let i = instances.length - 1; i >= 0; i--) {
    instances[i].$destroy(true)
  }
}

export default {
  install: Vue => {
    Vue.prototype.$umForm = CustomUmForm // 将组件暴露出去，并挂载在Vue的prototype上
  }
}
